function ViewState() {
    "use strict";
    this.Id = '';
    this.Value = '';
}
if (typeof exports !== 'undefined') {
    module.exports = ViewState;
}